module.exports = __webpack_public_path__ + "media/addons/ReturnArt-a25e28fd.svg";